import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useZocksQuota } from '../../components/ScopedBlock/hooks'
import { useDocumentTitle } from '../../common/useDocumentTitle'

import { selectShouldPollDocumentBatch } from '../../store/processDocument/processDocument'
import { startDocumentBatchPolling, stopDocumentBatchPolling } from '../../store/processDocument/documentBatch'
import { useAppDispatch, useAppSelector } from '../../store/hooks'

import { DELTA_TRIAL_FEATURES } from '../Plan/DeltaTrial/DeltaTrialFeatures'
import { Upsell } from '../Plan/DeltaTrial/Upsell/Upsell'

import { DocumentBatchInitialization } from './Initialization/DocumentBatchInitialization'
import { DocumentBatchPoller } from './Poller/DocumentBatchPoller'
import { DocumentLeaveGuardProvider } from './DocumentLeaveConfirmationModal'
import { DocumentBatch } from './DocumentBatch/DocumentBatch'

export const DocumentBatchPage = () => {
  useDocumentTitle('Documents')

  const { documentBatchId = null } = useParams()

  const { isFetching: quotasFetching, hasQuota, quotaSuccess } = useZocksQuota()

  if (!quotaSuccess && quotasFetching) {
    return null
  }

  if (!documentBatchId) {
    return null
  }

  const documentSummaryEnabled = hasQuota('ai.documentSummaryAgent.value')

  if (!documentSummaryEnabled) {
    return <Upsell feature={DELTA_TRIAL_FEATURES['processDocument']} />
  }

  return <DocumentBatchPageContent documentBatchId={documentBatchId} />
}

interface DocumentBatchPageContentProps {
  documentBatchId: string
}

const DocumentBatchPageContent: React.FC<DocumentBatchPageContentProps> = ({ documentBatchId }) => {
  const dispatch = useAppDispatch()

  const shouldPollDocumentBatch = useAppSelector(selectShouldPollDocumentBatch)

  useEffect(() => {
    if (shouldPollDocumentBatch) {
      dispatch(startDocumentBatchPolling())
    } else {
      dispatch(stopDocumentBatchPolling())
    }
  }, [dispatch, shouldPollDocumentBatch])

  return (
    <DocumentLeaveGuardProvider>
      <div className='full-size-content'>
        <DocumentBatchInitialization documentBatchId={documentBatchId} />
        <DocumentBatchPoller documentBatchId={documentBatchId} />
        <DocumentBatch />
      </div>
    </DocumentLeaveGuardProvider>
  )
}
